import { ZendeskTag } from '@color/lib';

import { ACTION_ITEM_SUBTYPES } from 'ui/UserDashboard/Pages/Home/ActionItems/constants';

export const ACTION_ITEM_SUBTYPE_TO_CONVERSATION_TAGS = new Map<string, ZendeskTag[]>([
  [
    ACTION_ITEM_SUBTYPES.CERVICAL_CANCER_SCHEDULE_IN_PERSON_SCREENING_VISIT_PLAN,
    [ZendeskTag.SCREENING_CERVICAL_CANCER],
  ],
  [ACTION_ITEM_SUBTYPES.LUNG_CANCER_SCHEDULE_LOW_DOSE_CT_SCAN, [ZendeskTag.SCREENING_LUNG_CANCER]],
  [ACTION_ITEM_SUBTYPES.PROSTATE_CANCER_SCHEDULE_IN_PERSON_EXAM, []], // TODO
  [ACTION_ITEM_SUBTYPES.PROSTATE_CANCER_SCHEDULE_IN_PERSON_SCREENING, []], // TODO
  [ACTION_ITEM_SUBTYPES.BREAST_CANCER_SCHEDULE_MAMMOGRAM, [ZendeskTag.SCREENING_BREAST_CANCER]],
  [
    ACTION_ITEM_SUBTYPES.COLORECTAL_CANCER_SCHEDULE_COLONOSCOPY,
    [ZendeskTag.SCREENING_COLORECTAL_CANCER],
  ],
]);
